import { InfoSet } from "../InfoSets/InfoSet";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export class Win32_OperatingSystemInfoJson {
//    boot_device: string;
//    build_number: string;
//    caption: string;
//    description: string;
//    free_physical_memory: string;
//    free_space_in_paging_files: string;
//    free_virtual_memory: string;
//    install_date: string;
//    last_boot_up_time: string;
//    locale: string;
//    manufacturer: string;
//    name: string;
//    number_of_licensed_users: string;
//    number_of_processes: string;
//    number_of_users: string;
//    registered_user: string;
//    serial_number: string;
//    version: string;
//    windows_directory: string;
//}

export class Win32_OperatingSystemInfo extends InfoSet {
  //  public static FromJson(json: Win32_OperatingSystemInfoJson, device: Device): Win32_OperatingSystemInfo {

  //      var result = new Win32_OperatingSystemInfo(device);

  //      if (json.boot_device !== undefined)
  //          result.BootDevice = json.boot_device;
  //      if (json.build_number !== undefined)
  //          result.BuildNumber = json.build_number;
  //      if (json.caption !== undefined)
  //          result.Caption = json.name;
  //      if (json.description !== undefined)
  //          result.Description = json.description;

  //      result.FreePhysicalMemory = NumberUtils.ToNumber(json.free_physical_memory);
  //      result.FreeSpaceInPagingFiles = NumberUtils.ToNumber(json.free_space_in_paging_files);
  //      result.FreeVirtualMemory = NumberUtils.ToNumber(json.free_virtual_memory);

  //      //if (json.install_date !== undefined)
  //      //    result.DNSHostname = json.host_name;

  //      if (json.locale !== undefined)
  //          result.Locale = json.locale;
  //      if (json.manufacturer !== undefined)
  //          result.Manufacturer = json.manufacturer;

  //      if (json.name !== undefined)
  //          result.Name = json.name;

  //      result.NumberOfLicensedUsers = NumberUtils.ToNumber(json.number_of_licensed_users);
  //      result.NumberOfProcesses = NumberUtils.ToNumber(json.number_of_processes);
  //      result.NumberOfUsers = NumberUtils.ToNumber(json.number_of_users);

  //      if (json.registered_user !== undefined) {
  //          result.RegisteredUser = json.registered_user;
  //      }
  //      if (json.serial_number !== undefined) {
  //          result.SerialNumber = json.serial_number;
  //      }
  //      if (json.version !== undefined) {
  //          result.Version = json.version;
  //      }

		//return result;
  //  }

    public BootDevice: string;
    public get HasBootDevice(): boolean {
        return !!this.BootDevice;
    }

    public BuildNumber: string;
    public get HasBuildNumber(): boolean {
        return !!this.BuildNumber;
    }

	public Caption: string;
	public get HasCaption():boolean{
        return !!this.Caption;
	}

	public Description: string;
	public get HasDescription(): boolean {
		return !!this.Description;
	}

    public FreePhysicalMemory: number;
    public get HasFreePhysicalMemory(): boolean {
        return this.FreePhysicalMemory > 0;
    }

    public FreeSpaceInPagingFiles: number;
    public get HasFreeSpaceInPagingFiles(): boolean {
        return this.FreeSpaceInPagingFiles > 0;
    }

    public FreeVirtualMemory: number;
    public get HasFreeVirtualMemory(): boolean {
        return this.FreeVirtualMemory > 0;
    }

	public InstallDate: number;
	public get HasInstallDate(): boolean {
		return !!this.InstallDate;
    }

    public LastBootUpTime: number;
    public get HasLastBootUpTime(): boolean {
        return !!this.LastBootUpTime;
    }

    public Locale: string;
    public get HasLocale(): boolean {
        return !!this.Locale;
    }

	public Manufacturer: string;
    public get HasManufacturer(): boolean {
        return !!this.Manufacturer;
	}

    public Name: string;
    public get HasName(): boolean {
        return !!this.Name;
    }

    public NumberOfLicensedUsers: number;
    public get HasNumberOfLicensedUsers(): boolean {
        return this.NumberOfLicensedUsers >= 0;
    }

    public NumberOfProcesses: number;
    public get HasNumberOfProcesses(): boolean {
        return this.NumberOfProcesses >= 0;
    }
		
    public NumberOfUsers: number;
    public get HasNumberOfUsers(): boolean {
        return this.NumberOfUsers >= 0;
    }

    public Organization: string
    public get HasOrganization(): boolean {
        return !!this.Organization;
    }

    public OSArchitecture: string
    public get HasOSArchitecture(): boolean {
        return !!this.OSArchitecture;
    }

    public RegisteredUser: string
    public get HasRegisteredUser(): boolean {
        return !!this.RegisteredUser;
    }

    public SerialNumber: string
    public get HasSerialNumber(): boolean {
        return !!this.SerialNumber;
	}

	public SystemDevice: string
	public get HasSystemDevice(): boolean {
		return !!this.SystemDevice;
	}

	public SystemDirectory: string
	public get HasSystemDirectory(): boolean {
		return !!this.SystemDirectory;
	}

	public SystemDrive: string
	public get HasSystemDrive(): boolean {
		return !!this.SystemDrive;
	}

	public TotalSwapSpaceSize: number;
	public get HasTotalSwapSpaceSize(): boolean {
		return (this.TotalSwapSpaceSize > 0);
	}

	public TotalVirtualMemorySize: number;
	public get HasTotalVirtualMemorySize(): boolean {
		return (this.TotalVirtualMemorySize > 0);
	}

	public TotalVisibleMemorySize: number;
	public get HasTotalVisibleMemorySize(): boolean {
		return (this.TotalVisibleMemorySize > 0);
	}

    public Version: string
    public get HasVersion(): boolean {
        return !!this.Version;
    }

    public WindowsDirectory: string
    public get HasWindowsDirectory(): boolean {
        return !!this.WindowsDirectory;
    }


	constructor(device: Device) {
		super(device);
		this.Init();
	}

    private Init() {
        this.BootDevice = "";
        this.BuildNumber = "";
        this.Caption = "";
        this.Description = "";
        this.FreePhysicalMemory = 0;
        this.FreeSpaceInPagingFiles = 0;
        this.FreeVirtualMemory = 0;

        this.Name = "";

        this.Locale = "";
        this.Manufacturer = "";
        this.NumberOfLicensedUsers = 0;
        this.NumberOfProcesses = 0;
        this.NumberOfUsers = 0;

        this.Organization = "";
        this.OSArchitecture = "";
        this.RegisteredUser = "";

        this.SerialNumber = "";

		this.Version = "";
        this.WindowsDirectory = "";
	}

	public Write(obj: any, context: any): void {
		obj.w32_os_info = {};
		obj = obj.w32_os_info;

		if (this.HasBootDevice)
			obj.boot_device = this.BootDevice;

		if (this.HasBuildNumber)
			obj.build_number = this.BuildNumber;

		if (this.HasCaption)
			obj.caption = this.Caption;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasFreePhysicalMemory)
			obj.free_physical_memory = ValueEncoder.EncodeInteger(this.FreePhysicalMemory);

		if (this.HasFreeSpaceInPagingFiles)
			obj.free_space_in_paging_files = ValueEncoder.EncodeInteger(this.FreeSpaceInPagingFiles);

		if (this.HasFreeVirtualMemory)
			obj.free_virtual_memory = ValueEncoder.EncodeInteger(this.FreeVirtualMemory);

		if (this.HasInstallDate)
			obj.install_date = ValueEncoder.EncodeInteger(this.InstallDate);

		if (this.HasLastBootUpTime)
			obj.last_boot_up_time = ValueEncoder.EncodeInteger(this.LastBootUpTime);

		if (this.HasLocale)
			obj.locale = this.Locale;

		if (this.HasManufacturer)
			obj.manufacturer = this.Manufacturer;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasNumberOfLicensedUsers)
			obj.number_of_licensed_users = ValueEncoder.EncodeInteger(this.NumberOfLicensedUsers);

		if (this.HasNumberOfProcesses)
			obj.number_of_processes = ValueEncoder.EncodeInteger(this.NumberOfProcesses);

		if (this.HasNumberOfUsers)
			obj.number_of_users = ValueEncoder.EncodeInteger(this.NumberOfUsers);

		if (this.HasOrganization)
			obj.organization = this.Organization;

		if (this.HasOSArchitecture)
			obj.os_architecture = this.OSArchitecture;

		if (this.HasRegisteredUser)
			obj.registered_user = this.RegisteredUser;

		if (this.HasSerialNumber)
			obj.serial_number = this.SerialNumber;

		if (this.HasSystemDevice)
			obj.system_device = this.SystemDevice;

		if (this.HasSystemDirectory)
			obj.system_directory = this.SystemDirectory;

		if (this.HasSystemDrive)
			obj.system_drive = this.SystemDrive;

		if (this.HasTotalSwapSpaceSize)
			obj.total_swap_space_size = ValueEncoder.EncodeInteger(this.TotalSwapSpaceSize);

		if (this.HasTotalVirtualMemorySize)
			obj.total_virtual_memory_size = ValueEncoder.EncodeInteger(this.TotalVirtualMemorySize);

		if (this.HasTotalVisibleMemorySize)
			obj.total_visible_memory_size = ValueEncoder.EncodeInteger(this.TotalVisibleMemorySize);

		if (this.HasVersion)
			obj.version = this.Version;

		if (this.HasWindowsDirectory)
			obj.windows_directory = this.WindowsDirectory;
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_os_info)
			throw new Error();
		obj = obj.w32_os_info;

		if (obj.boot_device !== undefined)
			this.BootDevice = obj.boot_device;

		if (obj.build_number !== undefined)
			this.BuildNumber = obj.build_number;

		if (obj.caption !== undefined)
			this.Caption = obj.caption;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.free_physical_memory !== undefined)
			this.FreePhysicalMemory = ValueEncoder.DecodeInteger(obj.free_physical_memory);

		if (obj.free_space_in_paging_files !== undefined)
			this.FreeSpaceInPagingFiles = ValueEncoder.DecodeInteger(obj.free_space_in_paging_files);

		if (obj.free_virtual_memory !== undefined)
			this.FreeVirtualMemory = ValueEncoder.DecodeInteger(obj.free_virtual_memory);

		if (obj.install_date !== undefined)
			this.InstallDate = ValueEncoder.DecodeInteger(obj.install_date);

		if (obj.last_boot_up_time !== undefined)
			this.LastBootUpTime = ValueEncoder.DecodeInteger(obj.last_boot_up_time);

		if (obj.locale !== undefined)
			this.Locale = obj.locale;

		if (obj.manufacturer !== undefined)
			this.Manufacturer = obj.manufacturer;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.number_of_licensed_users !== undefined)
			this.NumberOfLicensedUsers = ValueEncoder.DecodeInteger(obj.number_of_licensed_users);

		if (obj.number_of_processes !== undefined)
			this.NumberOfProcesses = ValueEncoder.DecodeInteger(obj.number_of_processes);

		if (obj.number_of_users !== undefined)
			this.NumberOfUsers = ValueEncoder.DecodeInteger(obj.number_of_users);

		if (obj.organization !== undefined)
			this.Organization = obj.organization;

		if (obj.os_architecture !== undefined)
			this.OSArchitecture = obj.os_architecture;

		if (obj.registered_user !== undefined)
			this.RegisteredUser = obj.registered_user;

		if (obj.serial_number !== undefined)
			this.SerialNumber = obj.serial_number;

		if (obj.system_device !== undefined)
			this.SystemDevice = obj.system_device;

		if (obj.system_directory !== undefined)
			this.SystemDirectory = obj.system_directory;

		if (obj.system_drive !== undefined)
			this.SystemDrive = obj.system_drive;

		if (obj.total_swap_space_size !== undefined)
			this.TotalSwapSpaceSize = ValueEncoder.DecodeInteger(obj.total_swap_space_size);

		if (obj.total_virtual_memory_size !== undefined)
			this.TotalVirtualMemorySize = ValueEncoder.DecodeInteger(obj.total_virtual_memory_size);

		if (obj.total_visible_memory_size !== undefined)
			this.TotalVisibleMemorySize = ValueEncoder.DecodeInteger(obj.total_visible_memory_size);

		if (obj.version !== undefined)
			this.Version = obj.version;

		if (obj.windows_directory !== undefined) 
			this.WindowsDirectory = obj.windows_directory;
	}

}
